export const rate2020To2021 = 2.1; // 2020年～2021年までの利率
export const rate2021To20240703 = 3.2; // 2021～2024/7/3までの利率の変更
export const rate = 4; // 2024/7/4～ 利率の変更

// 切り替えタイミングのジョブ情報
const jobNums = ["21JP0073TC", "21JP0072TC", "21JP0071TC"];
const getRate = (jobNum: string): number => {
	if (jobNums.includes(jobNum)) return rate2020To2021;
	return rate;
};

/**
 * 集計コスト
 */
export const aggregationCost = 10000;

export const makeCost = (point: number, jobNum: string): number => {
	return Math.floor(point * getRate(jobNum));
};
